module.exports = __webpack_public_path__ + "img/look-back.2d0994ec.svg";